(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Fix: the menu drawer sizes itself off the CSS variable
  // --header-bottom-position, which the theme calculates from the bounding
  // box of the whole header section. On the home page our video hero makes
  // that section ~90vh tall, which collapses the drawer's calculated height
  // to almost nothing. Rather than fight over that same variable (risk of
  // being overwritten by the theme's own script), compute the drawer height
  // ourselves from the nav bar's real height into a variable only this
  // script ever writes, and force the drawer to use it via !important
  // (see the .menu-drawer override in the <style> block above).
  (function () {
    function updateMenuDrawerHeight() {
      var headerEl = document.querySelector('.header');
      if (!headerEl) return;
      var headerHeight = Math.round(headerEl.offsetHeight);
      document.documentElement.style.setProperty('--menu-drawer-height', `calc(100vh - ${headerHeight}px)`);
    }

    window.addEventListener('resize', updateMenuDrawerHeight);
    window.addEventListener('load', updateMenuDrawerHeight);
    document.addEventListener('DOMContentLoaded', updateMenuDrawerHeight);

    document.querySelectorAll('.menu-drawer-container').forEach(function (details) {
      details.addEventListener('toggle', updateMenuDrawerHeight);
    });

    updateMenuDrawerHeight();
  })();

  // Seamless video loop: native <video loop> re-seeks to the start every
  // cycle, which causes a visible stutter. Instead, run two stacked copies
  // of the same video — while one plays, the other is idle. Shortly before
  // the playing one ends, start the idle one from frame 0 and crossfade the
  // opacity between them (see .header-video-bg / .is-active in the <style>
  // block above), so the loop point is masked instead of felt.
  (function () {
    var CROSSFADE_SECONDS = 0.6; // keep in sync with the CSS transition duration

    function initSeamlessVideo(container) {
      var videos = Array.prototype.slice.call(container.querySelectorAll('.header-video-bg'));
      if (videos.length < 2) return;

      var current = videos[0];
      var next = videos[1];
      var switching = false;

      function handleTimeUpdate(event) {
        var video = event.target;
        if (video !== current || switching) return;

        var remaining = video.duration - video.currentTime;
        if (isNaN(remaining) || remaining > CROSSFADE_SECONDS) return;

        switching = true;
        next.currentTime = 0;
        var playPromise = next.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
        next.classList.add('is-active');
        current.classList.remove('is-active');

        window.setTimeout(function () {
          current.pause();
          current.currentTime = 0;
          var swap = current;
          current = next;
          next = swap;
          switching = false;
        }, CROSSFADE_SECONDS * 1000);
      }

      videos.forEach(function (video) {
        video.addEventListener('timeupdate', handleTimeUpdate);
      });

      current.classList.add('is-active');
      var startPromise = current.play();
      if (startPromise && startPromise.catch) startPromise.catch(function () {});
    }

    function init() {
      document.querySelectorAll('[data-seamless-video]').forEach(initSeamlessVideo);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
